import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Card, Skeleton } from 'antd';
import { observer } from 'mobx-react';

import PartStore from '../../stores/PartStore';

/**
 * Placeholder where the first part will appear, while a batch of several parts uploads.
 * It disappears as soon as one part of the batch is added.
 *
 * The title is what tells the user the files were taken: it is large, in the accent color and
 * has its own spinner, because the skeleton alone looked like a part that failed to load.
 */
export const AddingPartsSkeleton = observer(() => {
    if (!PartStore.awaitingFirstPart) return null;

    const count = PartStore.pendingUploadCount;

    return (
        <Card
            aria-busy="true"
            aria-label="Adding parts"
            className="otf-parts-loading otf-adding-parts"
            data-testid="otf-adding-parts-skeleton"
            role="status"
            style={{ marginBottom: '2rem', borderRadius: 20 }}
        >
            <div className="otf-adding-parts-header">
                <LoadingOutlined className="otf-adding-parts-spinner" spin />
                <div>
                    <div className="otf-adding-parts-title" data-testid="otf-adding-parts-title">
                        Adding {count} {count === 1 ? 'part' : 'parts'}…
                    </div>
                    <div className="otf-adding-parts-hint">Your first part appears here as soon as it is ready.</div>
                </div>
            </div>
            <Skeleton active avatar={{ shape: 'square', size: 56 }} paragraph={{ rows: 3 }} />
        </Card>
    );
});

export default AddingPartsSkeleton;
